import _ from "lodash";
import React, { useEffect, useState } from "react";
import Draggable from "react-draggable";
import ReactTooltip from "react-tooltip";
import { useDispatch, useSelector } from "react-redux";
import LoadingOverlay from "react-loading-overlay";
import { FormField } from "../../recommendations/components/Bands/FormField";
import { assetSurveyOrder, assetSurveyStatus, autoFields, dropdownKeys, recommendationSurveyStatus } from "../constants";
import actions from "../actions";
import { DYNAMIC_FIELD_TYPES } from "../../common/constants";
import Portal from "../../common/components/Portal";
import ConfirmationModal from "../../common/components/ConfirmationModal";
import ServiceLifeChangeConfirmationModal from "../../common/components/ServiceLifeChangeConfirmationModal";
import Loader from "../../common/components/Loader";
import { FilterSearch } from "../../assets/components/FilterModal/FilterSearch";
import { RecommendationBand as AssetBand } from "../../recommendations/components/Bands/RecommendationBand";
import assetActions from "../../assets/actions";
import mrActions from "../../mobileRecommendation/actions";
import assetsSettingsAction from "../../assetSettings/actions";
import normalRecomStatusActions from "../../Status/action";
import projectActions from "../../project/actions";
import normalRecomActions from "../../recommendations/actions";
import "./survey-project.css";
import { getCurrentAge, getUsefullLifeRemaining } from "../../../config/utils";
import {
    SERVICE_LIFE_FIELD,
    getEndOfServiceLife,
    getUniformatAutoValues,
    getUniformatChangeSummary,
    getUniformatLevel,
    getUniformatValuesWithDerivedFields,
    getRecommendationLifecycleFieldKeys,
    getSubsystemServiceLifeChangeSummary
} from "../utils";

const AssetsMultiEdit = ({
    selectedAssetsIds = [],
    onCancel,
    handleMultiAssetUpdate,
    isMobileRecommendation = false,
    projectId = "",
    clientId = "",
    isAssetMngView
}) => {
    const { dropDownList, dropDownLoading, manufacturerCount } = useSelector(state => state.assetReducer);
    const {
        getAssetSurveyProjectById,
        getSurveyAssetsCommonDataLoading,
        updateMultipleAssetsLoading,
        getSurveyAssetsCommonData,
        updateMultiSurveyAssetLoading,
        uniformatList,
        getSuggestionDropdown,
        getAssetSurveyProjectByIdLoading,
        getSurveyAssetById
    } = useSelector(state => state?.assetSurveyProjectReducer);
    const { getProjectByIdResponse } = useSelector(state => state?.projectReducer);

    const { getSurveyTemplateById } = useSelector(state => state.surveyTemplateReducer);

    const {
        getMobileRecommendationCommonData,
        getMobileRecommendationCommonDataLoading,
        getMobileRecommendationTemplateResponse,
        getMobileRecommendationDropdownResponse,
        getMobileRecommendationDropdownResponseLoading,
        updateMultiMobileRecommendationLoading
    } = useSelector(state => state?.mobileRecommendationsReducer);

    const { getStaticDropdownValues } = useSelector(state => state?.assetSettingsReducer);
    const { getStatusDropdwnResponse } = useSelector(state => state?.recommendationStatusReducer);
    const { priorityElementsDropDownResponse, getRecommendationTemplatesResponse } = useSelector(state => state.recommendationsReducer);

    const dispatch = useDispatch();
    const [bandData, setBandData] = useState({});
    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [initialValues, setInitialValues] = useState(null);
    const [asset, setAsset] = useState({});
    const [showGroupUpdateConfirmation, setShowGroupUpdateConfirmation] = useState(false);
    const [fieldSearch, setFieldSearch] = useState("");
    const [showErrorBorder, setShowErrorBorder] = useState(false);
    const [errorParams, setErrorParams] = useState({});
    const [showBand, setShowBand] = useState({});
    const [pendingServiceLifeChange, setPendingServiceLifeChange] = useState(null);
    const [showFullUniformatDropdowns, setShowFullUniformatDropdowns] = useState({});
    const { client = {} } = getAssetSurveyProjectById?.data?.project ?? {};
    const clientid = isAssetMngView ? getSurveyTemplateById?.data?.client_id?.id : client?.id;
    const clientStandardHierarchy = [
        "assets.survey_target_id",
        "assets.cs_l1_type_id",
        "assets.cs_l2_category_id",
        "assets.cs_l3_subsystem_id",
        "assets.cs_l4_object_id",
        "assets.cs_l5_equipment_config_id",
        "assets.client_standards_id",
        clientid === "06356c0e-2ad9-4af8-8992-83e35233f7d4" || clientid === "300a3a47-20d4-46a8-bf9d-f7bde51bff62" ? "assets.asset_name" : ""
    ];

    useEffect(() => {
        isMobileRecommendation
            ? dispatch(mrActions.getMobileRecommendationCommonDataByIds({ ids: selectedAssetsIds }))
            : dispatch(actions?.getSurveyAssetsCommonDataByIds({ assets: selectedAssetsIds ?? [] }));
        if (isAssetMngView) dispatch(actions.getSurveyAssetById(selectedAssetsIds?.[0]));
        return () => {
            !isMobileRecommendation
                ? dispatch(actions?.resetMultiSurveyAssetCommonData({}))
                : dispatch(mrActions.resetMultiMobileRecommendationCommonData());
            setInitialValues({});
            setBandData({});
            setFieldSearch("");
            setErrorParams({});
            setShowErrorBorder(false);
        };
    }, []);

    useEffect(() => {
        if (getSurveyAssetsCommonData || getMobileRecommendationCommonData) {
            if (!isAssetMngView || (isAssetMngView && getSurveyAssetById?.data)) getInitialDropdowns();
        }
    }, [initialValues, getSurveyAssetById]);

    useEffect(() => {
        if (getAssetSurveyProjectById?.data?.project?.assigned_template?.asset_dynamic_fields && !isMobileRecommendation && !isAssetMngView) {
            let assetBands = getAssetSurveyProjectById.data.project.assigned_template.asset_dynamic_fields ?? {};
            assetBands = Object.entries(assetBands).reduce((acc, [key, value]) => {
                if (!value?.isStaticBand) {
                    acc[key] = value;
                }
                return acc;
            }, {});
            const tempBandData = {
                ...assetBands,
                "Additional Fields": {
                    index: 100,
                    fields: [
                        {
                            status: {
                                field_type: "select",
                                group_field: "Additional Fields",
                                field_name: "status",
                                label: "Status",
                                value: "",
                                field_options: assetSurveyOrder
                                    .filter(id => !assetSurveyStatus?.[id]?.disabled)
                                    .map(id => ({ key: id, value: assetSurveyStatus?.[id]?.value })),
                                rules: {}
                            }
                        }
                    ]
                }
            };
            setBandData(tempBandData);
        }
    }, [getAssetSurveyProjectById]);

    useEffect(() => {
        if (getSurveyTemplateById?.data?.data && isAssetMngView) {
            let assetBands = getSurveyTemplateById?.data?.data ?? {};
            assetBands = Object.entries(assetBands)?.reduce((acc, [key, value]) => {
                if (!value?.isStaticBand) {
                    if (Array.isArray(value?.fields)) {
                        // Hiding Client Standards and Uniformat fields from Asset Management group edit; unable to get surveyProjectId.
                        const removeKeys = [
                            "assets.uniformat_level_1_id",
                            "assets.uniformat_level_2_id",
                            "assets.uniformat_level_3_id",
                            "assets.uniformat_level_4_id",
                            "assets.uniformat_level_5_id",
                            "assets.uniformat_level_6_id",
                            "uniformat_level_5_description",
                            "uniformat_level_6_description",
                            "assets.survey_target_id",
                            "assets.cs_l1_type_id",
                            "assets.cs_l2_category_id",
                            "assets.cs_l3_subsystem_id",
                            "assets.cs_l4_object_id",
                            "assets.cs_l5_equipment_config_id",
                            "assets.client_standards_id",
                            "entity",
                            "assets.client_standards__description"
                        ];
                        value.fields = Array.isArray(value?.fields)
                            ? value?.fields?.filter(fieldObj => {
                                  return !Object.keys(fieldObj || {})?.some(fieldKey => removeKeys?.includes(fieldKey));
                              })
                            : value.fields;
                    }
                    acc[key] = value;
                }
                return acc;
            }, {});
            const tempBandData = {
                ...assetBands,
                "Additional Fields": {
                    index: 100,
                    fields: [
                        {
                            status: {
                                field_type: "select",
                                group_field: "Additional Fields",
                                field_name: "status",
                                label: "Status",
                                value: "",
                                field_options: assetSurveyOrder
                                    .filter(id => !assetSurveyStatus?.[id]?.disabled)
                                    .map(id => ({ key: id, value: assetSurveyStatus?.[id]?.value })),
                                rules: {}
                            }
                        }
                    ]
                }
            };
            setBandData(tempBandData);
        }
    }, [getSurveyTemplateById]);

    useEffect(() => {
        if (getMobileRecommendationTemplateResponse?.survey_recommendation_template?.dynamic_fields && isMobileRecommendation) {
            const tempBandData = {
                ...(getMobileRecommendationTemplateResponse?.survey_recommendation_template?.dynamic_fields ?? {}),
                "Additional Fields": {
                    index: 100,
                    fields: [
                        {
                            status: {
                                field_type: "select",
                                group_field: "Additional Fields",
                                field_name: "status",
                                label: "Status",
                                value: "",
                                field_options: Object?.entries(recommendationSurveyStatus ?? {})
                                    .filter(([eachKey, eachValue]) => !eachValue?.disabled)
                                    .map(([eKey, eValue]) => ({ key: eKey, value: eValue?.value })),
                                rules: {}
                            }
                        }
                    ]
                }
            };
            setBandData(tempBandData);
        }
    }, [getMobileRecommendationTemplateResponse]);

    useEffect(() => {
        if (getMobileRecommendationCommonData?.data?.recommendations && isMobileRecommendation) {
            setInitialValues({
                ...(getMobileRecommendationCommonData?.data?.recommendations?.dynamic_fields ?? {}),
                ...(getMobileRecommendationCommonData?.data?.recommendations?.status
                    ? { status: { value: getMobileRecommendationCommonData?.data?.recommendations?.status, isIndependent: true } }
                    : {})
            });
            const recommendationData = {
                ...(getMobileRecommendationCommonData?.data?.recommendations?.dynamic_fields ?? {}),
                ...(getMobileRecommendationCommonData?.data?.recommendations?.status
                    ? { status: { value: getMobileRecommendationCommonData?.data?.recommendations?.status, isIndependent: true } }
                    : {})
            };
            setAsset(recommendationData);
        }
    }, [getMobileRecommendationCommonData]);

    useEffect(() => {
        if (getSurveyAssetsCommonData?.data?.asset && !isMobileRecommendation) {
            setInitialValues({
                ...(getSurveyAssetsCommonData?.data?.asset?.asset_dynamic_fields ?? {}),
                ...(getSurveyAssetsCommonData?.data?.asset?.asset_static_fields ?? {}),
                ...(getSurveyAssetsCommonData?.data?.asset?.status
                    ? { status: { value: getSurveyAssetsCommonData?.data?.asset?.status, isIndependent: true } }
                    : {})
            });
            const assetData = {
                ...(getSurveyAssetsCommonData?.data?.asset?.asset_dynamic_fields ?? {}),
                ...(getSurveyAssetsCommonData?.data?.asset?.asset_static_fields ?? {}),
                ...(getSurveyAssetsCommonData?.data?.asset?.status
                    ? { status: { value: getSurveyAssetsCommonData?.data?.asset?.status, isIndependent: true } }
                    : {})
            };
            setAsset(assetData);
        }
    }, [getSurveyAssetsCommonData]);

    const getInitialDropdowns = () => {
        if (initialValues) {
            if (!isMobileRecommendation) {
                const staticFields = getSurveyAssetsCommonData?.data?.asset?.asset_static_fields;

                const { client = {}, region = {} } = getAssetSurveyProjectById?.data?.project ?? {};
                const client_id = isAssetMngView ? getSurveyTemplateById?.data?.client_id?.id : client?.id;
                const region_id = region?.id;
                if (client_id) {
                    dispatch(
                        assetActions.getDropdownList("trades", {
                            client_id
                        })
                    );

                    dispatch(assetActions.getDropdownList("building_types", { client_id }));

                    dispatch(
                        assetActions.getDropdownList("asset_statuses", {
                            client_id
                        })
                    );
                    dispatch(
                        assetActions.getDropdownList("asset_types", {
                            client_id
                        })
                    );
                    dispatch(
                        assetActions.getDropdownList("asset_conditions", {
                            client_id
                        })
                    );
                    dispatch(
                        assetActions.getDropdownList(
                            "regions",
                            {
                                client_id,
                                field: "regions"
                            },
                            undefined,
                            true
                        )
                    );
                    dispatch(
                        assetActions.getDropdownList("main_categories", {
                            client_id
                        })
                    );
                    dispatch(
                        assetActions.getDropdownList(
                            "client_standards",
                            {
                                client_id
                            },
                            {
                                asset_survey_project_id: isAssetMngView
                                    ? getSurveyAssetById?.data?.asset?.asset_survey_project?.id
                                    : getAssetSurveyProjectById?.data?.project?.id,
                                with_uniformat_parents: true
                            }
                        )
                    );
                    dispatch(actions.getSuggestionDropdownByClient(client_id));
                }
                if (region_id)
                    dispatch(
                        assetActions.getDropdownList(
                            "sites",
                            {
                                region_id,
                                client_id,
                                field: "sites"
                            },
                            undefined,
                            true
                        )
                    );

                if (staticFields) {
                    const site_id = staticFields?.["assets.site_id"]?.uuid;
                    const region_id = staticFields?.["assets.region_id"]?.uuid;
                    const building_id = staticFields?.["assets.building_id"]?.uuid;
                    const trade_id = staticFields?.["assets.trade_id"]?.uuid;
                    const system_id = staticFields?.["assets.system_id"]?.uuid;
                    const manufacturer_id = staticFields?.["assets.manufacturer"]?.uuid;

                    if (region_id)
                        dispatch(
                            assetActions.getDropdownList(
                                "sites",
                                {
                                    region_id: region_id,
                                    client_id,
                                    field: "sites"
                                },
                                undefined,
                                true
                            )
                        );

                    if (manufacturer_id)
                        dispatch(
                            assetActions.getDropdownList("manufacturers", {
                                current_manufacturer: manufacturer_id
                            })
                        );
                    else
                        dispatch(
                            assetActions.getDropdownList("manufacturers", {
                                client_id
                            })
                        );

                    if (site_id)
                        dispatch(
                            assetActions.getDropdownList(
                                "buildings",
                                {
                                    site_id,
                                    client_id,
                                    field: "buildings"
                                },
                                undefined,
                                true
                            )
                        );
                    if (building_id) {
                        dispatch(
                            assetActions.getDropdownList(
                                "floors",
                                {
                                    building_id,
                                    client_id,
                                    field: "floors"
                                },
                                undefined,
                                true
                            )
                        );
                        dispatch(
                            assetActions.getDropdownList(
                                "additions",
                                {
                                    building_id,
                                    client_id,
                                    field: "additions"
                                },
                                undefined,
                                true
                            )
                        );
                    }
                    if (trade_id)
                        dispatch(
                            assetActions.getDropdownList("systems", {
                                client_id,
                                trade_id
                            })
                        );
                    if (system_id)
                        dispatch(
                            assetActions.getDropdownList("sub_systems", {
                                client_id,
                                system_id
                            })
                        );
                }
                const fieldsToDispatch = [];

                Object.keys(initialValues ?? {}).forEach(eachFieldKey => {
                    if (eachFieldKey?.startsWith("assets.uniformat_level_")) {
                        fieldsToDispatch.push(eachFieldKey);
                    }
                });
                if (fieldsToDispatch.length > 0) {
                    dispatch(
                        actions?.getAssetSurveyUniformatDropdown({
                            asset_survey_template_id: isAssetMngView
                                ? getSurveyAssetById?.data?.asset?.asset_survey_template_id
                                : getAssetSurveyProjectById?.data?.project?.asset_survey_template?.id,
                            fields: JSON.stringify(fieldsToDispatch)
                        })
                    );
                }
                const clientStandardFieldsToDispatch = [];

                Object.keys(initialValues ?? {}).forEach(eachFieldKey => {
                    if (eachFieldKey?.startsWith("assets.cs_l")) {
                        clientStandardFieldsToDispatch.push(eachFieldKey);
                    }
                });
                if (clientStandardFieldsToDispatch?.length > 0) {
                    const params = {
                        client_id: client_id,
                        asset_survey_project_id: isAssetMngView
                            ? getSurveyAssetById?.data?.asset?.asset_survey_project?.id
                            : getAssetSurveyProjectById?.data?.project?.id,
                        fields: JSON.stringify([
                            "assets.survey_target_id",
                            "assets.cs_l1_type_id",
                            "assets.cs_l2_category_id",
                            "assets.cs_l3_subsystem_id",
                            "assets.cs_l4_object_id",
                            "assets.cs_l5_equipment_config_id"
                        ])
                    };
                    dispatch(assetsSettingsAction.getClientStandardStaticDropdown(params));
                }
            }
            if (isMobileRecommendation && initialValues) {
                if (projectId) {
                    dispatch(mrActions.getMobileRecommendationDropdowns("asset_condition_id", projectId));
                    dispatch(mrActions.getMobileRecommendationDropdowns("trade_id", projectId));
                    dispatch(mrActions.getMobileRecommendationDropdowns("category_id", projectId));
                    dispatch(mrActions.getMobileRecommendationDropdowns("recommendation_capital_type_id", projectId));
                    dispatch(mrActions.getMobileRecommendationDropdowns("funding_source_id", projectId));
                    dispatch(mrActions.getMobileRecommendationDropdowns("responsibility_id", projectId));
                    dispatch(mrActions.getMobileRecommendationDropdowns("criticality_id", projectId));
                    dispatch(mrActions.getMobileRecommendationDropdowns("department_id", projectId));
                    dispatch(mrActions.getMobileRecommendationDropdowns("initiative_id", { project_id: projectId }, true));
                    dispatch(projectActions.getUsersByProject(projectId, { is_surveyor_list: true }));
                    dispatch(normalRecomStatusActions.statusDropdown(projectId));
                    dispatch(normalRecomActions.getPriorityElementDropDownData(projectId));
                    dispatch(normalRecomActions?.getRecommendationTemplates(undefined, `/projects/${projectId}/recommendation_templates`));
                    const isAssetType = asset?.recommendation_type?.value?.toLowerCase() === "asset";
                    const manufacturer_id = isAssetType ? asset?.["assets.manufacturer_id"]?.uuid : asset?.["manufacturer_id"]?.uuid;

                    if (clientId) {
                        dispatch(mrActions.getMobileRecommendationDropdowns("region_id", clientId));
                        dispatch(mrActions.getMobileRecommendationDropdowns("main_building_type_id", { client_id: clientId }, true));
                        if (manufacturer_id)
                            dispatch(
                                assetActions.getDropdownList("manufacturers", {
                                    current_manufacturer: manufacturer_id,
                                    client_id: clientId
                                })
                            );
                        dispatch(assetActions.getDropdownList("asset_conditions", { client_id: clientId }));
                    }
                    const fields = initialValues ?? {};
                    const systemField = fields?.["system_id"];
                    const tradeField = fields?.["trade_id"];

                    const dropdownFields = {
                        building_id: ["floor", "addition_id"],
                        region_id: ["site_id"],
                        site_id: ["building_id"],
                        trade_id: ["system_id", ...(fields?.["system_id"]?.uuid || fields?.["system_id"]?.value ? [] : ["sub_system_id"])],
                        system_id: [...(fields?.["system_id"]?.uuid || fields?.["system_id"]?.value ? ["sub_system_id"] : [])]
                    };
                    Object.entries(fields ?? []).forEach(([eachFieldKey, eachFieldValue]) => {
                        if (
                            dropdownFields?.[eachFieldKey] &&
                            (eachFieldValue?.uuid || (eachFieldValue?.value && ["trade_id", "system_id"].includes(eachFieldKey)))
                        ) {
                            dropdownFields?.[eachFieldKey]?.forEach(e => {
                                let asParam = false;
                                if (["building_id", "system_id", "sub_system_id"].includes(e)) {
                                    asParam = true;
                                }
                                dispatch(
                                    mrActions.getMobileRecommendationDropdowns(
                                        e,
                                        e === "building_id"
                                            ? { site_id: eachFieldValue.uuid, project_id: projectId }
                                            : e === "system_id"
                                              ? { trade_id: eachFieldValue?.uuid || eachFieldValue?.value, project_id: projectId }
                                              : e === "sub_system_id"
                                                ? {
                                                      [eachFieldKey === "trade_id" ? "trade_id" : "system_id"]:
                                                          eachFieldValue?.uuid || eachFieldValue?.value,
                                                      project_id: projectId
                                                  }
                                                : eachFieldValue.uuid,
                                        asParam
                                    )
                                );
                            });
                        }
                    });
                    const trade_id = asset?.["trade_id"]?.uuid;
                    const system_id = asset?.["system_id"]?.uuid;
                    if (!trade_id && !tradeField?.value) dispatch(mrActions.getMobileRecommendationDropdowns("system_id", projectId));
                    if (!system_id && !trade_id && !tradeField?.value && !systemField?.value)
                        dispatch(mrActions.getMobileRecommendationDropdowns("sub_system_id", projectId));
                }
            }
        }
    };

    const confirmCancel = () => {
        if (_.isEqual(initialValues, asset)) {
            onCancel();
        } else {
            setShowConfirmModal(true);
        }
    };

    const handleBandClick = (key, value) => {
        setShowBand({
            ...showBand,
            [key]: value
        });
    };

    const getValue = (field_type, e, value) => {
        if ([DYNAMIC_FIELD_TYPES.SELECT, "custom_select"].includes(field_type)) {
            return e;
        }
        if (DYNAMIC_FIELD_TYPES.TEXT === field_type) {
            return e?.target?.value ?? "";
        }
        if (DYNAMIC_FIELD_TYPES.NUMBER === field_type) {
            return e?.value ?? "";
        }
        if (DYNAMIC_FIELD_TYPES.MEMO === field_type) {
            return value;
        }
        if (DYNAMIC_FIELD_TYPES.BOOLEAN === field_type) {
            return value;
        }
        if (DYNAMIC_FIELD_TYPES.DATE === field_type) {
            return e;
        }

        if (DYNAMIC_FIELD_TYPES.CURRENCY === field_type) {
            return value ?? "";
        }
    };

    const renderGroupUpdateConfirmationModal = () => {
        if (!showGroupUpdateConfirmation) return null;
        return (
            <Portal
                body={
                    <ConfirmationModal
                        heading={
                            <>
                                You are about to modify <span className="badge-red-circled">{selectedAssetsIds.length}</span> Survey
                                {isMobileRecommendation ? " Recommendations" : " Assets"}.
                                <br /> This action cannot be undone!
                            </>
                        }
                        type="cancel"
                        message={"Are you sure you want to continue?"}
                        onNo={() => setShowGroupUpdateConfirmation(false)}
                        onYes={() => {
                            setShowGroupUpdateConfirmation(false);
                            updateSelectedRecommendations();
                        }}
                    />
                }
                onCancel={() => setShowGroupUpdateConfirmation(false)}
            />
        );
    };

    const updateSelectedRecommendations = () => {
        let formattedData = {};
        Object.entries(asset ?? {}).forEach(([eachFieldKey, eachFieldValue]) => {
            if (!isMobileRecommendation) {
                const staticFields = getSurveyAssetsCommonData?.data?.asset?.asset_static_fields;
                const dynamicFields = getSurveyAssetsCommonData?.data?.asset?.asset_dynamic_fields;
                const isStaticField = staticFields?.[eachFieldKey];
                const isDynamicField = dynamicFields?.[eachFieldKey];
                if (isStaticField && !_.isEqual(isStaticField, eachFieldValue)) {
                    formattedData = {
                        ...formattedData,
                        asset_static_fields: { ...(formattedData?.asset_static_fields ?? {}), [eachFieldKey]: eachFieldValue }
                    };
                } else if (isDynamicField && !_.isEqual(isDynamicField, eachFieldValue)) {
                    formattedData = {
                        ...formattedData,
                        asset_dynamic_fields: { ...(formattedData?.asset_dynamic_fields ?? {}), [eachFieldKey]: eachFieldValue }
                    };
                } else if (eachFieldValue?.isIndependent && !_.isEqual(eachFieldValue?.value, initialValues?.status?.value)) {
                    formattedData = { ...formattedData, [eachFieldKey]: eachFieldValue?.value };
                }
            } else {
                const dynamicFields = initialValues;
                const initialField = dynamicFields?.[eachFieldKey];
                const fields = Object.values(bandData).reduce((acc, item) => {
                    acc = {
                        ...acc,
                        ...(item?.fields ?? []).reduce((a, i) => {
                            a = { ...a, ...i };
                            return a;
                        }, {})
                    };
                    return acc;
                }, {});
                if (initialField && !_.isEqual(initialField, eachFieldValue)) {
                    const field = fields?.[eachFieldKey];
                    formattedData = {
                        ...formattedData,
                        dynamic_fields: { ...(formattedData?.dynamic_fields ?? {}), [eachFieldKey]: eachFieldValue },
                        log_fields: {
                            ...(formattedData?.log_fields ?? {}),
                            [eachFieldKey]: {
                                value: eachFieldValue?.value,
                                uuid: eachFieldValue?.uuid,
                                invalid: eachFieldValue?.uuid
                                    ? false
                                    : field?.field_type === "custom_select" && eachFieldValue?.value && !eachFieldValue?.uuid,
                                old_value: {
                                    value: initialField?.value,
                                    uuid: initialField?.uuid,
                                    invalid: initialField?.uuid
                                        ? false
                                        : field?.field_type === "custom_select" && initialField?.value && !initialField?.uuid,
                                    label: field?.label
                                }
                            }
                        }
                    };
                } else if (eachFieldValue?.isIndependent && eachFieldValue?.value) {
                    formattedData = { ...formattedData, [eachFieldKey]: eachFieldValue?.value };
                }
            }
        });
        if (validateForm(formattedData)) {
            handleMultiAssetUpdate(formattedData);
        }
    };

    const getFormUniformatAutoValues = (fieldName, value, data = asset) => {
        if (!value) return {};
        const option = uniformatList?.[fieldName]?.find(e => e?.id === value);
        return getUniformatAutoValues(option, fieldName, field => field in (data ?? {}));
    };

    const applyUniformatAutoValues = (data, values = {}) => {
        if (!Object.keys(values ?? {}).length) return data;
        const derivedValues = getUniformatValuesWithDerivedFields(values, field => data?.[field]?.value);
        let updatedData = { ...data };
        Object.entries(derivedValues).forEach(([field, fieldValue]) => {
            if (field in updatedData || field in (values ?? {})) updatedData[field] = { uuid: "", value: fieldValue };
        });
        return updatedData;
    };

    const getMobileRecomLifecycleKeys = (data = asset) =>
        getRecommendationLifecycleFieldKeys(data?.recommendation_type?.value?.toLowerCase() === "asset");

    const getSubsystemServiceLifeValues = (value, data) => {
        const keys = getMobileRecomLifecycleKeys(data);
        if (!value || !(keys.serviceLife in (data ?? {}))) return {};
        const serviceLife = getMobileRecommendationDropdownResponse?.sub_system_id?.find(e => e?.id === value)?.service_life;
        return serviceLife === null || serviceLife === undefined || serviceLife === "" ? {} : { [keys.serviceLife]: serviceLife };
    };

    const getPendingSubsystemChange = (value, data) => {
        const keys = getMobileRecomLifecycleKeys(data);
        if (!value || !(keys.serviceLife in (data ?? {}))) return null;
        const subSystem = getMobileRecommendationDropdownResponse?.sub_system_id?.find(e => e?.id === value);
        const summary = getSubsystemServiceLifeChangeSummary({
            subSystem,
            serviceLifeKey: keys.serviceLife,
            currentServiceLife: data?.[keys.serviceLife]?.value
        });
        return summary && { ...summary, source: { from: asset?.sub_system_id?.value, to: subSystem?.name ?? subSystem?.label ?? "" } };
    };

    const applySubsystemServiceLife = (data, values = {}) => {
        const keys = getMobileRecomLifecycleKeys(data);
        if (!(keys.serviceLife in (values ?? {}))) return data;
        const serviceLife = values[keys.serviceLife] ?? "";
        const installedYear = data?.[keys.installedYear]?.value;
        const derivedValues = {
            [keys.serviceLife]: serviceLife,
            [keys.usefulLifeRemaining]: getUsefullLifeRemaining(installedYear, serviceLife),
            [keys.endOfServiceLife]: getEndOfServiceLife(installedYear, serviceLife)
        };
        const updatedData = { ...data };
        Object.entries(derivedValues).forEach(([field, fieldValue]) => {
            if (field in updatedData) updatedData[field] = { uuid: "", value: fieldValue };
        });
        return updatedData;
    };

    const applyPendingServiceLifeValues = (data, values) =>
        pendingServiceLifeChange?.sourceField === "sub_system_id" ? applySubsystemServiceLife(data, values) : applyUniformatAutoValues(data, values);

    const handleServiceLifeChangeApply = selectedFields => {
        if (!pendingServiceLifeChange) return;
        const { data, values } = pendingServiceLifeChange;
        const selectedValues = Object.fromEntries(Object.entries(values ?? {}).filter(([field]) => selectedFields?.includes(field)));
        setAsset(Object.keys(selectedValues).length ? applyPendingServiceLifeValues(data, selectedValues) : data);
        setPendingServiceLifeChange(null);
    };

    const renderServiceLifeChangeConfirmationModal = () => {
        if (!pendingServiceLifeChange) return null;
        const {
            changes = [],
            serviceLifeChanged,
            newServiceLife,
            serviceLifeKey = SERVICE_LIFE_FIELD,
            source = {},
            sourceLabel = "Uniformat",
            entityLabel = "Asset"
        } = pendingServiceLifeChange;
        const lifecycleKeys = getRecommendationLifecycleFieldKeys(serviceLifeKey.startsWith("assets."));
        const serviceLife = newServiceLife;
        const installedYear = asset?.[lifecycleKeys.installedYear]?.value;
        const hasInstalledYear = !!installedYear && lifecycleKeys.installedYear in (asset ?? {});
        const showEndOfServiceLife = serviceLifeChanged && hasInstalledYear && lifecycleKeys.endOfServiceLife in (asset ?? {});
        const showUsefulLifeRemaining = serviceLifeChanged && hasInstalledYear && lifecycleKeys.usefulLifeRemaining in (asset ?? {});
        const currentServiceLifeValue = asset?.[serviceLifeKey]?.value;
        const currentUlr = asset?.[lifecycleKeys.usefulLifeRemaining]?.value;
        const oldULR = currentUlr || currentUlr === 0 ? currentUlr : getUsefullLifeRemaining(installedYear, currentServiceLifeValue);
        const rows = [
            ...changes,
            ...(showEndOfServiceLife
                ? [
                      {
                          field: lifecycleKeys.endOfServiceLife,
                          label: "End of Service Life",
                          derived: true,
                          from: getEndOfServiceLife(installedYear, currentServiceLifeValue),
                          to: getEndOfServiceLife(installedYear, serviceLife)
                      }
                  ]
                : []),
            ...(showUsefulLifeRemaining
                ? [
                      {
                          field: lifecycleKeys.usefulLifeRemaining,
                          label: "Useful Life Remaining",
                          derived: true,
                          from: oldULR,
                          to: getUsefullLifeRemaining(installedYear, serviceLife)
                      }
                  ]
                : [])
        ];

        return (
            <Portal
                body={
                    <ServiceLifeChangeConfirmationModal
                        sourceLabel={sourceLabel}
                        entityLabel={entityLabel}
                        isMultiEdit
                        sourceTo={source?.to ?? ""}
                        rows={rows}
                        onApply={handleServiceLifeChangeApply}
                        onCancel={() => setPendingServiceLifeChange(null)}
                    />
                }
                onCancel={() => setPendingServiceLifeChange(null)}
            />
        );
    };

    const getUniformatDescriptionKey = fieldName => fieldName?.match(/uniformat_level_\d+_description/)?.[0];

    const syncUniformatDescriptions = (tempData, changedLevelName, value, uniformatList) => {
        const changedLevel = getUniformatLevel(changedLevelName);
        if (!changedLevel) return tempData;

        const selectedUniformat = uniformatList?.[changedLevelName]?.find(e => e?.id === value) ?? "";
        Object.keys(tempData || {}).forEach(descriptionField => {
            const level = getUniformatLevel(descriptionField);
            const descriptionKey = getUniformatDescriptionKey(descriptionField);
            if (!descriptionKey) return;

            const shouldClear = (!value && level >= changedLevel) || level > changedLevel;
            const uniformat =
                level === changedLevel
                    ? selectedUniformat
                    : uniformatList?.[`assets.uniformat_level_${level}_id`]?.find(
                          e => e?.id === selectedUniformat?.[`assets.uniformat_level_${level}_id`]
                      );

            tempData = {
                ...tempData,
                [descriptionField]: {
                    ...tempData?.[descriptionField],
                    uuid: "",
                    value: shouldClear ? "" : (uniformat?.[descriptionField] ?? uniformat?.[descriptionKey] ?? "")
                }
            };
        });
        return tempData;
    };

    const clearUniformatChildren = (tempData, changedLevelName, uniformatLevels) => {
        const thisLevelIdx = uniformatLevels.findIndex(level => changedLevelName === level);
        for (let idx = thisLevelIdx + 1; idx < uniformatLevels.length; idx++) {
            const child = uniformatLevels[idx];
            tempData = {
                ...tempData,
                [child]: { uuid: "", value: "" }
            };
        }
        tempData = syncUniformatDescriptions(tempData, changedLevelName, "", uniformatList);
        return tempData;
    };

    const autoSelectUniformatParents = (tempData, name, value, uniformatLevels, uniformatList) => {
        const thisLevelIdx = uniformatLevels.findIndex(level => name === level);
        const uniformData = uniformatList?.[name]?.find(e => e?.id === value);
        for (let idx = thisLevelIdx - 1; idx >= 0; idx--) {
            const parentLevel = uniformatLevels[idx];
            if (uniformData?.[parentLevel] && (!tempData?.[parentLevel]?.uuid || tempData?.[parentLevel]?.uuid !== uniformData[parentLevel])) {
                const parentObj = uniformatList?.[parentLevel]?.find(e => e?.id === uniformData[parentLevel]);
                tempData = {
                    ...tempData,
                    [parentLevel]: {
                        uuid: uniformData[parentLevel],
                        value: parentObj?.label || ""
                    }
                };
            }
        }
        return tempData;
    };
    const isEmptyFieldData = fieldData =>
        _.isPlainObject(fieldData) &&
        !fieldData?.uuid &&
        !fieldData?.isIndependent &&
        (fieldData?.value === "" || fieldData?.value === undefined || fieldData?.value === null);

    const normalizeClearedFields = data => {
        const normalizedData = { ...data };
        Object.entries(normalizedData || {})?.forEach(([key, fieldData]) => {
            if (!(key in (initialValues ?? {})) && isEmptyFieldData(fieldData)) {
                delete normalizedData?.[key];
            }
        });
        return normalizedData;
    };
    const priorityTotalCalculation = (bandData, datas) => {
        const priorityBandFields = bandData?.Priority?.fields || [];

        const filteredPriorityElements = (
            (priorityBandFields || [])?.filter(field => {
                const key = Object.keys(field)[0];
                const fieldData = field[key];
                return fieldData && fieldData.hasOwnProperty("priority_element_option");
            }) || []
        )?.map(f => {
            const key = Object.keys(f || {})?.[0];
            const valueObject = datas?.[key] || { uuid: "", value: 0 };
            let numericValue = 0;
            if (valueObject?.value) {
                numericValue = valueObject?.priority_element_option ?? asset?.[key]?.priority_element_option ?? 0;
            }
            return {
                ...f[key],
                key,
                priority_element_option: numericValue,
                valueObject
            };
        });
        const priorityTotal = (filteredPriorityElements || [])?.reduce((sum, item) => sum + (item.priority_element_option || 0), 0);
        const criticalityData = getMobileRecommendationDropdownResponse?.["criticality_id"];
        let criticalityId = asset?.criticality_id?.uuid;
        let criticalityValue = asset?.criticality_id?.value;
        const cs = getProjectByIdResponse?.miscellaneous?.criticality_score;

        if (cs !== "year" && priorityTotal > 0 && criticalityData?.length) {
            const match = criticalityData.find(c => priorityTotal >= Number(c?.start_range) && priorityTotal <= Number(c?.end_range));
            criticalityId = match?.id || "";
            criticalityValue = match?.name;
        }
        return { priorityTotal, newCriticalityId: { id: criticalityId, name: criticalityValue } };
    };

    const handleChange = e => {
        let tempData = { ...asset };
        const { name, value, isCustomSelect } = e;
        const priorityField = (bandData?.Priority?.fields ?? [])?.map(fieldObj => Object.keys(fieldObj || {})?.[0])?.find(key => key === e?.name);
        const selectedPriority = (bandData.Priority?.fields ?? [])?.find(obj => obj.hasOwnProperty(priorityField));
        const PriorityFieldValue = priorityField ? Object.keys(selectedPriority?.[priorityField] || {})?.includes("priority_element_option") : null;
        const isAssetType = asset?.recommendation_type?.value?.toLowerCase() === "asset";
        if (isCustomSelect) {
            tempData = onInputChangeDropdownUpdates(name, value, tempData);
            const staticFields = getSurveyAssetsCommonData?.data?.asset?.asset_static_fields ?? {};
            const customFieldValue = staticFields?.[name]?.value ?? "";
            if (value) {
                if (customFieldValue === value) tempData = { ...tempData, [name]: { uuid: "", value } };
                else {
                    if (name.startsWith("assets.uniformat_level_")) {
                        tempData = autoSelectUniformatParents(tempData, name, value, uniformatLevels, uniformatList);
                        tempData = clearUniformatChildren(tempData, name, uniformatLevels);
                    }

                    if (name === "assets.client_standards_id") {
                        const levels = [
                            ...uniformatLevels,
                            "assets.csp_unit",
                            "assets.service_life",
                            "assets.client_standards__description",
                            "entity",
                            "assets.cs_l1_type_id",
                            "assets.cs_l2_category_id",
                            "assets.cs_l3_subsystem_id",
                            "assets.cs_l4_object_id",
                            "assets.cs_l5_equipment_config_id",
                            clientid === "06356c0e-2ad9-4af8-8992-83e35233f7d4" || clientid === "300a3a47-20d4-46a8-bf9d-f7bde51bff62"
                                ? "assets.asset_name"
                                : ""
                        ];

                        const clientStandardKeys = {
                            "assets.csp_unit": "assets.csp_unit",
                            "assets.service_life": "assets.service_life",
                            "assets.client_standards__description": "description",
                            "assets.uniformat_level_1_id": "uniformat_level_1_id",
                            "assets.uniformat_level_2_id": "uniformat_level_2_id",
                            "assets.uniformat_level_3_id": "uniformat_level_3_id",
                            "assets.uniformat_level_4_id": "uniformat_level_4_id",
                            "assets.uniformat_level_5_id": "uniformat_level_5_id",
                            "assets.uniformat_level_6_id": "uniformat_level_6s_id"
                        };
                        const entityLevels = {
                            entity: "entity",
                            "assets.survey_target_id": "assets.survey_target_id",
                            "assets.cs_l1_type_id": "assets.cs_l1_type_id",
                            "assets.cs_l2_category_id": "assets.cs_l2_category_id",
                            "assets.cs_l3_subsystem_id": "assets.cs_l3_subsystem_id",
                            "assets.cs_l4_object_id": "assets.cs_l4_object_id",
                            "assets.cs_l5_equipment_config_id": "assets.cs_l5_equipment_config_id",
                            "assets.asset_name": "assets.asset_name"
                        };

                        const clientStandardObject = dropDownList?.client_standards?.find(e => e?.id === value);
                        levels.forEach(level => {
                            if (tempData?.[level]) {
                                // const uniformName = uniformatList?.[level]?.find(
                                //     e => e?.id === clientStandardObject?.[clientStandardKeys?.[level]]
                                // )?.name;
                                // const uniformId = uniformatList?.[tempData?.[level]]?.find(
                                //     e => e?.id === clientStandardObject?.[clientStandardKeys?.[tempData?.[level]]]
                                // )?.id;
                                const isEntityObject = entityLevels?.[level];

                                let uniformName = "";
                                let uniformId = "";
                                if (isEntityObject) {
                                    const fieldKey = level === "entity" ? "assets.survey_target_id" : level;
                                    const clientStandardValue = clientStandardObject?.[fieldKey];
                                    if (level === "assets.asset_name") {
                                        tempData = {
                                            ...tempData,
                                            [level]: { ...tempData?.[level], value: clientStandardObject?.name ?? "" }
                                        };
                                        return;
                                    } else if (!clientStandardValue) {
                                        tempData = {
                                            ...tempData,
                                            [level]: tempData?.[level]
                                        };
                                        return;
                                    }

                                    const selectedData = getStaticDropdownValues?.data?.[fieldKey]?.find(e => e?.id === clientStandardValue);
                                    uniformName = selectedData?.name || "";
                                    uniformId = selectedData?.id || "";
                                } else {
                                    const rawId = clientStandardObject?.[clientStandardKeys?.[tempData?.[level]]];
                                    const matched = uniformatList?.[level]?.find(e => e?.id === rawId);
                                    uniformName = matched?.label || "";
                                    uniformId = matched?.id || "";
                                }

                                tempData = {
                                    ...tempData,
                                    [level]: {
                                        ...tempData?.[level],
                                        uuid: uniformId ? uniformId : "",
                                        value: uniformName ? uniformName : (clientStandardObject?.[clientStandardKeys?.[level]] ?? "")
                                    }
                                };
                            }
                        });
                        const selectedUniformatLevel = [...uniformatLevels]
                            .reverse()
                            .find(level => clientStandardObject?.[clientStandardKeys?.[level]]);
                        tempData = syncUniformatDescriptions(
                            tempData,
                            selectedUniformatLevel,
                            clientStandardObject?.[clientStandardKeys?.[selectedUniformatLevel]] || "",
                            uniformatList
                        );
                    }
                    if (name?.startsWith("assets.cs_")) {
                        const levels = [
                            "assets.survey_target_id",
                            "assets.cs_l1_type_id",
                            "assets.cs_l2_category_id",
                            "assets.cs_l3_subsystem_id",
                            "assets.cs_l4_object_id",
                            "assets.cs_l5_equipment_config_id",
                            "assets.client_standards_id"
                        ];

                        const normalizedName = name === "entity" ? "assets.survey_target_id" : name;
                        const changedLevelIndex = levels.indexOf(normalizedName);

                        if (changedLevelIndex === -1) {
                            if (name in tempData) {
                                tempData = {
                                    ...tempData,
                                    [name]: tempData?.[name]
                                };
                            }
                            return;
                        }

                        const selectedData = getStaticDropdownValues?.data?.[normalizedName]?.find(e => e?.id === value);

                        levels.forEach((level, index) => {
                            if (!(level in tempData)) return;
                            const dropdownData = getStaticDropdownValues?.data?.[level] ?? [];
                            if (index < changedLevelIndex) {
                                const parentId = selectedData?.[level];
                                if (parentId) {
                                    const matched = dropdownData.find(e => e?.id === parentId);
                                    tempData[level === "assets.survey_target_id" ? "entity" : level] = {
                                        uuid: parentId,
                                        value: matched?.name ?? ""
                                    };
                                }
                            } else if (index > changedLevelIndex) {
                                tempData[level === "assets.survey_target_id" ? "entity" : level] = {
                                    uuid: "",
                                    value: ""
                                };
                            } else {
                                tempData[level === "assets.survey_target_id" ? "entity" : level] =
                                    tempData?.[level === "assets.survey_target_id" ? "entity" : level];
                            }
                        });
                    }

                    const dropdownOptions = isMobileRecommendation
                        ? name === "recommendation_status_id"
                            ? getStatusDropdwnResponse?.recommendation_status_data
                            : name === "manufacturer_id" ||
                                name === "assets.manufacturer_id" ||
                                name === "asset_conditions" ||
                                name === "assets.client_asset_condition_id"
                              ? dropDownList?.[dropdownKeys?.[name]]
                              : getMobileRecommendationDropdownResponse?.[name]
                        : dropDownList?.[dropdownKeys?.[name]];
                    if (name === "sub_system_id" && dropdownOptions?.length) {
                        const {
                            system_id = "",
                            system_name = "",
                            trade_id = "",
                            trade_name = ""
                        } = dropdownOptions.find(option => option.id === value) ?? {};
                        if (tempData?.system_id) {
                            tempData = {
                                ...tempData,
                                system_id: {
                                    uuid: system_id,
                                    value: system_name
                                }
                            };
                        }
                        if (tempData?.trade_id) {
                            tempData = {
                                ...tempData,
                                trade_id: {
                                    uuid: trade_id,
                                    value: trade_name
                                }
                            };
                        }
                    }
                    if (name === "system_id" && dropdownOptions?.length) {
                        const { trade_id = "", trade_name = "" } = dropdownOptions.find(option => option.id === value) ?? {};
                        if (tempData?.trade_id) {
                            tempData = {
                                ...tempData,
                                trade_id: {
                                    uuid: trade_id,
                                    value: trade_name
                                }
                            };
                        }
                    }
                    if ((name === "building_id" || name === "assets.building_id") && dropdownOptions?.length) {
                        const { building_type_id = "", description = "" } = dropdownOptions.find(option => option.id === value) ?? {};
                        const { id: main_building_type_id = "", name: main_building_type_name = "" } =
                            dropDownList?.[dropdownKeys?.["buildings.main_building_type_id"]]?.find(e => {
                                return dropDownList?.[dropdownKeys?.[name]]?.some(
                                    item => item?.id === value && item?.main_building_type_id === e?.id
                                );
                            }) ?? {};
                        tempData = {
                            ...tempData,
                            [isMobileRecommendation ? "main_building_type_id" : "buildings.main_building_type_id"]: {
                                uuid: isMobileRecommendation ? building_type_id : main_building_type_id,
                                value: isMobileRecommendation ? description : main_building_type_name
                            },
                            ...(!isMobileRecommendation
                                ? {
                                      "buildings.description": {
                                          uuid: "",
                                          value: dropDownList?.["buildings"]?.find(e => e?.id === value)?.description ?? ""
                                      }
                                  }
                                : {})
                        };
                    }
                    if (PriorityFieldValue && isMobileRecommendation) {
                        const priorityDropdownList = priorityElementsDropDownResponse?.priority_elements
                            ?.find(e => e?.id === name)
                            ?.options?.find(priority => priority?.id === value);
                        const updatedValue = {
                            ...tempData,
                            [name]: {
                                ...tempData?.[name],
                                uuid: priorityDropdownList?.id,
                                value: priorityDropdownList?.name,
                                priority_element_option: priorityDropdownList?.value
                            }
                        };
                        const priorityDependencyFields = priorityTotalCalculation(bandData, updatedValue);
                        tempData = {
                            ...tempData,
                            ...updatedValue,
                            ["priority"]: {
                                ...tempData?.["priority"],
                                uuid: "",
                                value: priorityDependencyFields?.priorityTotal
                            },
                            ["criticality_id"]: {
                                ...tempData?.["criticality_id"],
                                uuid: priorityDependencyFields?.newCriticalityId?.id ?? "",
                                value: priorityDependencyFields?.newCriticalityId?.name ?? ""
                            }
                        };
                    } else {
                        const matchedUniformat = name?.startsWith("assets.uniformat_level_")
                            ? uniformatList?.[name]?.find(e => e?.id === value)
                            : null;
                        tempData = {
                            ...tempData,
                            [name]: {
                                uuid: value,
                                value: matchedUniformat
                                    ? (matchedUniformat?.label ?? "")
                                    : name === "recommendation_capital_type_id" && isMobileRecommendation
                                      ? getMobileRecommendationDropdownResponse?.[name]?.find(e => e?.id === value)?.display_name
                                      : dropdownOptions?.find(e => e?.id === value)?.name
                            }
                        };
                        if (name.startsWith("assets.uniformat_level_")) {
                            tempData = syncUniformatDescriptions(tempData, name, value, uniformatList);
                        }
                    }
                }
            } else if (name.startsWith("assets.uniformat_level_")) {
                const thisLevelIdx = uniformatLevels.findIndex(level => name === level);
                for (let idx = thisLevelIdx; idx < uniformatLevels.length; idx++) {
                    const levelField = uniformatLevels[idx];
                    tempData = {
                        ...tempData,
                        [levelField]: { uuid: "", value: "" }
                    };
                }
                tempData = syncUniformatDescriptions(tempData, name, "", uniformatList);
            } else if (name.startsWith("assets.cs_l")) {
                const thisLevelIdx = clientStandardHierarchy.findIndex(level => name === level);
                for (let idx = thisLevelIdx; idx < clientStandardHierarchy.length; idx++) {
                    const levelField = clientStandardHierarchy[idx];
                    if (tempData?.[levelField]) {
                        tempData = {
                            ...tempData,
                            [levelField]: { uuid: "", value: "" }
                        };
                    }
                }
            } else if (
                name.startsWith("assets.client_standards_id") &&
                (clientid === "06356c0e-2ad9-4af8-8992-83e35233f7d4" || clientid === "300a3a47-20d4-46a8-bf9d-f7bde51bff62")
            ) {
                tempData = { ...tempData, [name]: { uuid: "", value: "" }, "assets.asset_name": { uuid: "", value: "" } };
            } else if (PriorityFieldValue && isMobileRecommendation) {
                const updatedValue = {
                    ...tempData,
                    [name]: {
                        ...tempData?.[name],
                        uuid: "",
                        value: "",
                        priority_element_option: ""
                    }
                };
                const priorityDependencyFields = priorityTotalCalculation(bandData, updatedValue);
                tempData = {
                    ...tempData,
                    ...updatedValue,
                    ["priority"]: {
                        ...tempData?.["priority"],
                        uuid: "",
                        value: priorityDependencyFields?.priorityTotal
                    },
                    ["criticality_id"]: {
                        ...tempData?.["criticality_id"],
                        uuid: priorityDependencyFields?.newCriticalityId?.id ?? "",
                        value: priorityDependencyFields?.newCriticalityId?.name ?? ""
                    }
                };
            } else if (name.startsWith("assets.building_id")) {
                tempData = {
                    ...tempData,
                    [name]: { uuid: "", value: "" },
                    ["buildings.description"]: { uuid: "", value: "" },
                    ["buildings.main_building_type_id"]: { uuid: "", value: "" }
                };
            } else {
                tempData = { ...tempData, [name]: { uuid: "", value: "" } };
            }
        } else {
            tempData = { ...tempData, [name]: { uuid: "", value } };
            if (["assets.installed_year", "installed_year"].includes(name)) {
                if (
                    (asset?.["assets.service_life"] && asset?.["assets.usefull_life_remaining"]) ||
                    (asset?.["service_life"] && asset?.["usefull_life_remaining"])
                ) {
                    tempData = {
                        ...tempData,
                        [isMobileRecommendation
                            ? !isAssetType
                                ? "usefull_life_remaining"
                                : "assets.usefull_life_remaining"
                            : "assets.usefull_life_remaining"]: {
                            uuid: "",
                            value: getUsefullLifeRemaining(
                                value,
                                asset?.[isMobileRecommendation ? (!isAssetType ? "service_life" : "assets.service_life") : "assets.service_life"]
                                    ?.value
                            )
                        }
                    };
                    if (isMobileRecommendation && isAssetType) {
                        tempData = {
                            ...tempData,
                            ["assets.end_of_service_life"]: {
                                uuid: "",
                                value: getEndOfServiceLife(
                                    value,
                                    asset?.[isMobileRecommendation ? (!isAssetType ? "service_life" : "assets.service_life") : "assets.service_life"]
                                        ?.value
                                )
                            }
                        };
                    }
                }
                if (asset?.["assets.current_age"] || asset?.["current_age"]) {
                    tempData = {
                        ...tempData,
                        [isMobileRecommendation ? (!isAssetType ? "current_age" : "assets.current_age") : "assets.current_age"]: {
                            uuid: "",
                            value: getCurrentAge(value)
                        }
                    };
                }
            }
            if (["assets.service_life", "service_life"].includes(name)) {
                if (
                    (asset?.["assets.usefull_life_remaining"] && asset?.["assets.installed_year"]) ||
                    (asset?.["usefull_life_remaining"] && asset?.["installed_year"])
                ) {
                    tempData = {
                        ...tempData,
                        [isMobileRecommendation
                            ? !isAssetType
                                ? "usefull_life_remaining"
                                : "assets.usefull_life_remaining"
                            : "assets.usefull_life_remaining"]: {
                            uuid: "",
                            value: getUsefullLifeRemaining(
                                asset?.[
                                    isMobileRecommendation ? (!isAssetType ? "installed_year" : "assets.installed_year") : "assets.installed_year"
                                ]?.value,
                                value
                            )
                        }
                    };
                    if (isMobileRecommendation && isAssetType) {
                        tempData = {
                            ...tempData,
                            ["assets.end_of_service_life"]: {
                                uuid: "",
                                value: getEndOfServiceLife(
                                    asset?.[
                                        isMobileRecommendation ? (!isAssetType ? "installed_year" : "assets.installed_year") : "assets.installed_year"
                                    ]?.value,
                                    value
                                )
                            }
                        };
                    }
                }
            }
            if (name === "status") {
                tempData = {
                    ...tempData,
                    status: {
                        value,
                        isIndependent: true
                    }
                };
            }
            if (name === "entity") {
                const thisLevelIdx = clientStandardHierarchy.findIndex(level => name === level);

                for (let idx = thisLevelIdx; idx < clientStandardHierarchy.length; idx++) {
                    const levelField = clientStandardHierarchy[idx];
                    if (tempData?.[levelField]) {
                        tempData = {
                            ...tempData,
                            [levelField]: { uuid: "", value: "" }
                        };
                    }
                }
            }
        }

        if (isCustomSelect && !isMobileRecommendation && name?.startsWith("assets.uniformat_level_")) {
            const autoValues = getFormUniformatAutoValues(name, value, tempData);
            const summary = getUniformatChangeSummary(autoValues, field => tempData?.[field]?.value);
            if (summary) {
                setPendingServiceLifeChange({
                    data: normalizeClearedFields(tempData),
                    ...summary,
                    source: { from: asset?.[name]?.value, to: uniformatList?.[name]?.find(e => e?.id === value)?.label ?? "" }
                });
                return;
            }
            tempData = applyUniformatAutoValues(tempData, autoValues);
        }

        if (isCustomSelect && isMobileRecommendation && name === "sub_system_id") {
            const pendingChange = getPendingSubsystemChange(value, tempData);
            if (pendingChange) {
                setPendingServiceLifeChange({ data: normalizeClearedFields(tempData), ...pendingChange });
                return;
            }
            tempData = applySubsystemServiceLife(tempData, getSubsystemServiceLifeValues(value, tempData));
        }

        setAsset(normalizeClearedFields(tempData));
    };
    const getValidId = (...values) => values.find(v => v !== undefined && v !== null && v !== "") ?? null;

    const onInputChangeDropdownUpdates = (fieldName, value, tempData) => {
        const { client = {} } = getAssetSurveyProjectById?.data?.project ?? {};
        const client_id = isAssetMngView ? getSurveyTemplateById?.data?.client_id?.id : client?.id;

        const fieldDropdowns = isMobileRecommendation
            ? {
                  region_id: ["site_id"],
                  site_id: ["building_id"],
                  building_id: ["floor", "addition_id"],
                  trade_id: ["system_id", "sub_system_id"],
                  system_id: ["sub_system_id", "system_id"],
                  sub_system_id: ["system_id", "sub_system_id"]
              }
            : {
                  "assets.region_id": ["sites"],
                  "assets.site_id": ["buildings"],
                  "assets.building_id": ["floors", "additions"],
                  "assets.trade_id": ["systems"],
                  "assets.system_id": ["sub_systems"]
              };

        const paramKeys = isMobileRecommendation
            ? { region_id: "region_id", site_id: "site_id", building_id: "building_id", trade_id: "trade_id", system_id: "system_id" }
            : {
                  "assets.region_id": "region_id",
                  "assets.site_id": "site_id",
                  "assets.building_id": "building_id",
                  "assets.trade_id": "trade_id",
                  "assets.system_id": "system_id"
              };

        const clearKeys = isMobileRecommendation
            ? {
                  region_id: ["site_id", "building_id", "floor", "addition_id"],
                  site_id: ["building_id", "floor", "addition_id"],
                  building_id: ["floor", "addition_id"],
                  trade_id: ["system_id", "sub_system_id"],
                  system_id: ["sub_system_id"],
                  main_building_type_id: ["building_id", "floor", "addition_id"]
              }
            : {
                  "assets.region_id": ["assets.site_id", "assets.building_id", "assets.floor_id", "assets.addition_id", "buildings.description"],
                  "assets.site_id": ["assets.building_id", "assets.floor_id", "assets.addition_id", "buildings.description"],
                  "assets.building_id": ["assets.addition_id", "assets.floor_id"],
                  "assets.trade_id": ["assets.system_id"],
                  "assets.system_id": ["assets.sub_system_id"],
                  "buildings.main_building_type_id": ["assets.building_id", "assets.floor_id", "assets.addition_id"]
              };

        let params = { [paramKeys?.[fieldName]]: value };
        if (["assets.trade_id", "assets.system_id"].includes(fieldName)) params = { ...params, client_id };
        const isMobileDropdownFields = ["regions", "sites", "buildings", "floors", "additions"];
        const selectedSubSystem = getMobileRecommendationDropdownResponse?.["sub_system_id"]?.find(e => e?.id === value) ?? {};
        const trade_id = asset?.["trade_id"]?.uuid;
        const selectedSystem = getMobileRecommendationDropdownResponse?.["system_id"]?.find(e => e?.id === value) ?? {};
        const system_id = asset?.["system_id"]?.uuid;

        if (fieldDropdowns?.[fieldName]) {
            fieldDropdowns?.[fieldName].forEach(e =>
                isMobileRecommendation
                    ? dispatch(
                          mrActions.getMobileRecommendationDropdowns(
                              e,
                              e === "building_id"
                                  ? { site_id: value, project_id: projectId }
                                  : e === "system_id"
                                    ? {
                                          trade_id:
                                              fieldName === "sub_system_id"
                                                  ? getValidId(selectedSubSystem?.trade_id, trade_id, "")
                                                  : fieldName === "system_id"
                                                    ? getValidId(selectedSystem?.trade_id, trade_id, "")
                                                    : value,
                                          project_id: projectId
                                      }
                                    : e === "sub_system_id"
                                      ? {
                                            [fieldName === "system_id" && value
                                                ? "system_id"
                                                : fieldName === "sub_system_id"
                                                  ? getValidId(selectedSubSystem?.system_id, system_id)
                                                      ? "system_id"
                                                      : "trade_id"
                                                  : "trade_id"]:
                                                fieldName === "trade_id"
                                                    ? value
                                                    : fieldName === "sub_system_id"
                                                      ? getValidId(selectedSubSystem?.system_id, system_id, selectedSubSystem?.trade_id, trade_id)
                                                      : fieldName === "system_id"
                                                        ? value
                                                            ? value
                                                            : (trade_id ?? "")
                                                        : value,
                                            project_id: projectId
                                        }
                                      : value,
                              e === "building_id" || e === "system_id" || e === "sub_system_id"
                          )
                      )
                    : dispatch(
                          assetActions.getDropdownList(
                              e,
                              { ...params, ...(isMobileDropdownFields?.includes(e) && { client_id, field: e }) },
                              undefined,
                              true
                          )
                      )
            );
        }
        if (clearKeys?.[fieldName]) {
            clearKeys?.[fieldName].forEach(e => {
                if (asset?.[e]) tempData = { ...tempData, [e]: { uuid: "", value: "" } };
            });
        }
        return tempData;
    };

    const renderConfirmationModal = () => {
        if (!showConfirmModal) return null;
        return (
            <Portal
                body={
                    <ConfirmationModal
                        heading={`Do you want to ${asset ? "cancel" : "clear"} and lose all changes?`}
                        type="cancel"
                        message={"This action cannot be reverted, are you sure that you need to cancel?"}
                        onNo={() => setShowConfirmModal(false)}
                        onYes={() => onCancel()}
                    />
                }
                onCancel={() => setShowConfirmModal(false)}
            />
        );
    };

    const validateForm = onChangeData => {
        const { asset_static_fields = {}, asset_dynamic_fields = {}, dynamic_fields = {} } = onChangeData ?? {};
        const dataToBeValidated = { ...(asset_static_fields ?? {}), ...(asset_dynamic_fields ?? {}), ...(dynamic_fields ?? {}) };
        let errorParams = {};
        let showErrorBorder = false;
        let fields = [];
        Object.values(bandData ?? {}).forEach(bandFields => {
            const formattedBandField = (bandFields?.fields ?? []).map(e => Object.values(e ?? {})?.[0]);
            fields = [...fields, ...(formattedBandField ?? [])];
        });
        Object.entries(dataToBeValidated).forEach(([eachFieldKey, eachFieldValue]) => {
            const fieldInBand = fields?.find(each => eachFieldKey === each?.field_name);
            const isRequired = fields?.find(each => each?.rules?.mandatory && eachFieldKey === each?.field_name);
            if (isRequired && (typeof eachFieldValue?.value === "string" ? !eachFieldValue?.value?.trim()?.length : !eachFieldValue?.value)) {
                errorParams[eachFieldKey] = `* ${fieldInBand?.label} is required`;
                showErrorBorder = true;
            }
        });
        setShowErrorBorder(showErrorBorder);
        setErrorParams(errorParams);
        if (showErrorBorder) return false;
        return true;
    };

    const handleInputChange = (newValue, { action }, manufacturerId) => {
        const { client = {} } = getAssetSurveyProjectById?.data?.project ?? {};
        const client_id = isAssetMngView ? getSurveyTemplateById?.data?.client_id?.id : client?.id;
        if (action === "input-change" || action === "input-click" || action === "input-blur") {
            dispatch(
                assetActions.getDropdownList("manufacturers", {
                    search: newValue,
                    current_manufacturer: manufacturerId && manufacturerId,
                    client_id
                })
            );
            return newValue;
        }
    };

    const multiselectClass = field => {
        let selectboxClass = "";
        const initialValue = initialValues?.[field]?.uuid ? initialValues?.[field]?.uuid : initialValues?.[field]?.value;
        const assetValue = asset[field]?.uuid ? asset[field]?.uuid : asset[field]?.value;
        const hasValue = value => value !== undefined && value !== null && value !== "";
        if ((hasValue(assetValue) || hasValue(initialValue)) && _.isEqual(assetValue?.toString(), initialValue?.toString())) {
            selectboxClass = "common-data ";
        } else if ((hasValue(assetValue) || hasValue(initialValue)) && !_.isEqual(assetValue?.toString(), initialValue?.toString())) {
            selectboxClass = "dirty-field ";
        }
        if (isMobileRecommendation && field === "description") selectboxClass += "mobile-recom-autosuggestion ";
        return selectboxClass;
    };

    const disabledKeys = ["assets.current_age", "assets.end_of_service_life", "assets.usefull_life_remaining", "usefull_life_remaining"];

    let fieldsToBeRendered = [];

    if (fieldSearch && fieldSearch?.trim()?.length) {
        fieldsToBeRendered = fieldsToBeRendered.filter(field => field.label.toLowerCase().includes(fieldSearch.toLowerCase()));
    }

    const renderUniformatFullDropdownToggle = fieldName => (
        <span className="uniformat-full-dropdown-toggle mb-1 mt-2" onClick={e => e.stopPropagation()}>
            <input
                type="checkbox"
                className="uniformat-full-dropdown-toggle__checkbox"
                checked={!!showFullUniformatDropdowns?.[fieldName]}
                onChange={e => setShowFullUniformatDropdowns(prevState => ({ ...prevState, [fieldName]: e.target.checked }))}
            />
            <span className="uniformat-full-dropdown-toggle__text">Show full dropdown values</span>
        </span>
    );

    const getFilteredUniformatOptions = (fieldName, assetData, showFullDropdown = false) => {
        const levelMatch = fieldName?.match(/uniformat_level_(\d+)_id/);
        const level = Number(levelMatch?.[1]);
        const list = uniformatList?.[fieldName] ?? [];
        if (!level || !list.length) return [];

        if (level === 1 || showFullDropdown) {
            return list.map(opt => ({ ...opt, label: opt.name, value: opt.id }));
        }

        let parentIdx = level - 1;
        let parentField, parentUuid;
        while (parentIdx > 0) {
            parentField = `assets.uniformat_level_${parentIdx}_id`;
            parentUuid = assetData?.[parentField]?.uuid;
            if (parentUuid) break;
            parentIdx--;
        }

        if (!parentUuid) {
            return list.map(opt => ({ ...opt, label: opt.name, value: opt.id }));
        }

        return list.filter(opt => opt?.[parentField] === parentUuid).map(opt => ({ ...opt, label: opt.name, value: opt.id }));
    };

    const getFilteredOptions = levelKey => {
        const hierarchy = [
            "entity",
            "assets.survey_target_id",
            "assets.cs_l1_type_id",
            "assets.cs_l2_category_id",
            "assets.cs_l3_subsystem_id",
            "assets.cs_l4_object_id",
            "assets.cs_l5_equipment_config_id",
            "assets.client_standards_id"
        ];

        if (levelKey === "assets.client_standards_id") {
            const clientList = dropDownList?.["client_standards"] ?? [];

            for (let i = hierarchy.length - 2; i >= 0; i--) {
                const parentKey = hierarchy?.[i];
                const parentValue = asset?.[parentKey];
                const entityValue = parentValue?.value;
                if (entityValue || parentValue?.uuid) {
                    const filtered = clientList?.filter(item => {
                        const compareValue = parentKey === "entity" ? entityValue : parentValue?.uuid;
                        return item?.[parentKey === "entity" ? "assets.survey_target" : parentKey] === compareValue;
                    });

                    return filtered;
                }
            }
            return clientList;
        }

        const currentIndex = hierarchy?.indexOf(levelKey);
        const currentList = getStaticDropdownValues?.data?.[levelKey] ?? [];

        if (currentIndex === 0) return currentList;

        for (let i = currentIndex - 1; i >= 0; i--) {
            const parentKey = hierarchy?.[i];
            const parentValue = asset?.[parentKey];
            const entityValue = parentValue?.value;

            if (entityValue || parentValue?.uuid) {
                return currentList?.filter(item => {
                    const compareValue = parentKey === "entity" ? entityValue : parentValue?.uuid;
                    return item?.[parentKey === "entity" ? "survey_target" : parentKey] === compareValue;
                });
            }
        }

        return currentList;
    };
    const recomDropdown = (eachFieldKey, eachFieldValue, eachBand) => {
        const parentMap = {
            region_id: ["site_id"],
            site_id: ["building_id"],
            building_id: ["floor", "addition_id", "main_building_type_id"]
        };

        const parentEntry = Object.entries(parentMap).find(([parentKey, children]) => children.includes(eachFieldKey));
        if (parentEntry) {
            const [parentKey] = parentEntry;

            const parentValue =
                bandData?.[eachBand]?.fields?.map(fieldObj => {
                    return fieldObj?.[parentKey]?.value;
                }) || [];
            if (!parentValue) {
                return [];
            }
        }

        if (eachFieldKey === "recommendation_capital_type_id") {
            return (
                getMobileRecommendationDropdownResponse?.[eachFieldKey]?.map(e => ({
                    id: e?.id,
                    name: e?.display_name
                })) || []
            );
        }

        if (
            eachFieldKey === "manufacturer_id" ||
            eachFieldKey === "assets.manufacturer_id" ||
            eachFieldKey === "asset_conditions" ||
            eachFieldKey === "assets.client_asset_condition_id"
        ) {
            return dropDownList?.[dropdownKeys?.[eachFieldKey]] || [];
        }

        if (eachFieldValue && "priority_element_option" in eachFieldValue) {
            return (priorityElementsDropDownResponse?.priority_elements || [])?.find(e => e?.id === eachFieldKey)?.options || [];
        }
        return (
            getMobileRecommendationDropdownResponse?.[eachFieldKey] ||
            eachFieldValue.field_options?.map(e => ({
                id: e?.value,
                name: e?.value
            })) ||
            []
        );
    };
    const getSuggestions = value => {
        const inputValue = value?.trim()?.toLowerCase() || "";

        return (getRecommendationTemplatesResponse?.project_sub_system_recommendation_templates || [])
            ?.filter(
                item =>
                    item.text_format?.toString()?.toLowerCase().includes(inputValue) ||
                    item.description?.toString()?.toLowerCase().includes(inputValue)
            )
            ?.slice(0, 40)
            ?.map(item => item?.description || item?.text_format);
    };
    const groupedOptions = (getStatusDropdwnResponse?.recommendation_status_data || [])
        .reduce((acc, item) => {
            if (item?.key === "deleted") return acc;
            const groupName = item?.group_name || "Others";

            let group = acc?.find(g => g?.label === groupName);
            if (!group) {
                group = { label: groupName, options: [] };
                acc.push(group);
            }
            group?.options?.push({
                label: item?.name,
                value: item?.id,
                description: item?.description,
                key: item?.key
            });

            return acc;
        }, [])
        ?.sort((a, b) => {
            return (a.label === "Others") - (b.label === "Others") || a.label.localeCompare(b.label);
        });
    const renderFormField = (eachField, i, eachBand) => {
        let fieldItem = {};
        const newOptions = {
            ...(isMobileRecommendation
                ? {
                      ...(getMobileRecommendationCommonData?.data?.recommendations?.static_new_values ?? {}),
                      ...(getMobileRecommendationCommonData?.data?.recommendations?.dynamic_new_values ?? {})
                  }
                : {
                      ...(getSurveyAssetsCommonData?.data?.asset?.static_new_values ?? {}),
                      ...(getSurveyAssetsCommonData?.data?.asset?.dynamic_new_values ?? {})
                  })
        };

        const customFieldOptions = eachField?.field_type === DYNAMIC_FIELD_TYPES.SELECT ? eachField?.field_options : null;
        const uniformatLevel = Number(eachField?.field_name?.match(/^assets\.uniformat_level_(\d+)_id$/)?.[1]);
        const isUniformatField = eachField?.field_type === "custom_select" && uniformatLevel > 1;
        const showFullUniformatDropdown = showFullUniformatDropdowns?.[eachField?.field_name];
        const dropdownOptions = isMobileRecommendation
            ? recomDropdown(eachField?.field_name, eachField, eachBand)
            : dropDownList?.[dropdownKeys?.[eachField?.field_name]];
        const field_options =
            eachField?.field_type === "custom_select"
                ? newOptions[eachField?.field_name]?.length > 0
                    ? [
                          {
                              label: "New",
                              options: newOptions[eachField?.field_name].map(option => ({
                                  label: option ?? "Unknown",
                                  value: option ?? "unknown"
                              }))
                          },
                          {
                              label: "Existing",
                              options: eachField?.field_name?.startsWith("assets.uniformat_level")
                                  ? getFilteredUniformatOptions(eachField?.field_name, asset, showFullUniformatDropdown)
                                  : eachField?.field_name?.startsWith("assets.cs_l") ||
                                      eachField?.field_name?.startsWith("assets.survey_target_id") ||
                                      eachField?.field_name?.startsWith("assets.client_standards_id")
                                    ? (getFilteredOptions(eachField?.field_name) || [])?.map(eachOption => ({
                                          label: eachOption?.name,
                                          value: eachOption?.id
                                      }))
                                    : (dropdownOptions ?? []).map(option => ({
                                          label: option?.name ?? "Unnamed",
                                          value: option?.id ?? "unknown"
                                      }))
                          }
                      ]
                    : eachField?.field_name?.startsWith("assets.uniformat_level")
                      ? getFilteredUniformatOptions(eachField?.field_name, asset, showFullUniformatDropdown)
                      : eachField?.field_name?.startsWith("assets.cs_l") ||
                          eachField?.field_name?.startsWith("assets.survey_target_id") ||
                          eachField?.field_name?.startsWith("assets.client_standards_id")
                        ? getFilteredOptions(eachField?.field_name)
                        : eachField?.field_name === "recommendation_status_id" && isMobileRecommendation
                          ? (groupedOptions ?? [])
                          : (dropdownOptions ?? [])
                : (customFieldOptions?.map(e => ({
                      id: eachField?.field_name === "status" ? parseInt(e?.key) : isMobileRecommendation ? e?.label || e?.value : e?.value,
                      name: isMobileRecommendation ? e?.label || e?.value : e?.value
                  })) ?? []);

        if (
            [
                "assets.asset_condition_description",
                "assets.site_id",
                "assets.building_id",
                "assets.current_age",
                "assets.end_of_service_life",
                "assets.usefull_life_remaining",
                "assets.uniformat_level_6_description",
                "assets.subcategory2_description"
            ].includes(eachField?.field_name)
        ) {
            fieldItem = { ...fieldItem, rules: { read_only: true } };
        }

        if (["assets.boiler_hp", "assets.mca", "assets.latitude", "assets.longitude"].includes(eachField?.field_name)) {
            fieldItem = { ...fieldItem, rules: { ...fieldItem?.rules, decimal_scale: 6 } };
        }

        const value =
            !autoFields.includes(eachField?.field_name) && ["custom_select"].includes(eachField?.field_type)
                ? asset?.[eachField?.field_name]?.uuid
                    ? asset?.[eachField?.field_name]?.uuid
                    : asset?.[eachField?.field_name]?.value
                : asset?.[eachField?.field_name]?.value;
        return (
            <FormField
                isLoading={
                    isMobileRecommendation
                        ? getMobileRecommendationDropdownResponseLoading?.[eachField?.field_name]
                        : eachField?.field_name !== "assets.manufacturer" && dropDownLoading?.[dropdownKeys?.[eachField?.field_name]]
                }
                label={eachField?.label}
                labelAddon={isUniformatField ? renderUniformatFullDropdownToggle(eachField?.field_name) : null}
                fieldKey={eachField?.field_name}
                fieldParam={eachField?.field_name}
                fieldType={
                    isMobileRecommendation
                        ? eachField?.field_type
                        : autoFields.includes(eachField?.field_name)
                          ? DYNAMIC_FIELD_TYPES.TEXT
                          : eachField?.field_type
                }
                value={value}
                bandId={`band${i + 1}`}
                bandShown={true}
                handleBandClick={() => {}}
                onChange={(e, value) => {
                    handleChange({
                        name: eachField?.field_name,
                        value: getValue(eachField?.field_type, e, value),
                        isCustomSelect: eachField?.field_type === "custom_select"
                    });
                }}
                showErrorBorder={showErrorBorder && errorParams?.[eachField?.field_name]}
                fieldItem={{
                    field_options,
                    rules: {
                        mandatory: eachField?.rules?.mandatory,
                        read_only:
                            (isMobileRecommendation
                                ? getMobileRecommendationDropdownResponseLoading?.[eachField?.field_name] ||
                                  eachField?.field_name === "mobile_recomm_notes_temp" ||
                                  eachField?.rules?.read_only
                                : eachField?.field_name !== "assets.manufacturer" && dropDownLoading?.[dropdownKeys?.[eachField?.field_name]]) ||
                            autoFields.includes(eachField?.field_name) ||
                            disabledKeys.includes(eachField?.field_name) ||
                            eachField?.rules?.read_only,
                        decimal_scale: eachField?.rules?.decimal_scale,
                        allow_negative: eachField?.rules?.allow_negative,
                        thousand_separator: eachField?.rules?.thousand_separator,
                        prefix: eachField?.rules?.prefix,
                        suffix: eachField?.rules?.suffix,
                        ...(isMobileRecommendation && (eachField?.field_name === "installed_year" || eachField?.field_name === "asset.installed_year")
                            ? { format: eachField?.rules?.format }
                            : {})
                    },
                    invalid:
                        eachField?.field_type === "custom_select" && !asset?.[eachField?.field_name]?.uuid && asset?.[eachField?.field_name]?.value,
                    className: isMobileRecommendation ? "mob-recom-field" : "mobile-asset-field"
                }}
                isAsset
                isSurveyMultiAssetField
                hasGroupedByOptions={
                    newOptions[eachField?.field_name]?.length > 0 || (eachField?.field_name === "recommendation_status_id" && isMobileRecommendation)
                }
                multiselectClass={multiselectClass}
                hasEmptyOption={isMobileRecommendation || eachField?.field_name !== "status"}
                isManufacturer={
                    eachField?.field_name === "assets.manufacturer" ||
                    eachField?.field_name === "manufacturer_id" ||
                    eachField?.field_name === "assets.manufacturer_id"
                }
                handleInputChange={(newValue, { action }) =>
                    (eachField?.field_name === "assets.manufacturer" ||
                        eachField?.field_name === "manufacturer_id" ||
                        eachField?.field_name === "assets.manufacturer_id") &&
                    handleInputChange(newValue, { action }, asset?.[eachField?.field_name]?.uuid)
                }
                manufacturerCount={
                    eachField?.field_name === "assets.manufacturer" ||
                    eachField?.field_name === "manufacturer_id" ||
                    eachField?.field_name === "assets.manufacturer_id"
                        ? manufacturerCount?.count
                        : 0
                }
                isLoadingDrop={
                    (eachField?.field_name === "assets.manufacturer" ||
                        eachField?.field_name === "manufacturer_id" ||
                        eachField?.field_name === "assets.manufacturer_id") &&
                    dropDownLoading?.[dropdownKeys?.[eachField?.field_name]]
                }
                suggestionArray={
                    !isMobileRecommendation
                        ? ((getSuggestionDropdown?.data ?? [])?.find(e => e?.key === eachField?.field_name)?.value ?? [])
                        : eachField?.field_name === "description"
                          ? getSuggestions() || []
                          : []
                }
                hasSuggestionSearch={isMobileRecommendation && eachField?.field_name === "description"}
                hasSuggestionClear={isMobileRecommendation && eachField?.field_name === "description"}
                colSize={isMobileRecommendation && eachField?.field_name === "description" ? 9 : ""}
                isMobileRecommendation={isMobileRecommendation}
            />
        );
    };
    const assetBands = Object.keys(bandData ?? {}).sort((a, b) => bandData?.[a]?.index - bandData?.[b]?.index);

    let dataNotFound = true;

    assetBands.forEach((band, i) => {
        if (dataNotFound && fieldSearch?.trim()?.length)
            dataNotFound = !bandData?.[band]?.fields?.some(eachField =>
                Object?.values(eachField)?.[0]?.label?.toLowerCase()?.includes(fieldSearch.toLowerCase())
            );
    });
    const hiddenFieldsForAsset = ["asset_condition_id", "installed_year", "service_life", "usefull_life_remaining", "crv"];
    return (
        <LoadingOverlay
            active={
                getSurveyAssetsCommonDataLoading ||
                updateMultiSurveyAssetLoading ||
                getMobileRecommendationCommonDataLoading ||
                (isAssetMngView && getAssetSurveyProjectByIdLoading) ||
                (isMobileRecommendation && updateMultiMobileRecommendationLoading)
            }
            spinner={<Loader />}
            fadeSpeed={10}
        >
            <ReactTooltip id="asset_details" effect="solid" backgroundColor="#007bff" className="rc-tooltip-custom-class" />
            <div className="dtl-sec modal-recom-tab-view col-md-12">
                <Draggable cancel=".not-draggable" positionOffset={{ x: "0%", y: "0%" }}>
                    <div className="tab-dtl region-mng additional-dtl addition-edit" style={{ cursor: "move" }}>
                        <div class="close-btn-otr">
                            <button
                                type="button"
                                className="close not-draggable"
                                data-dismiss="modal"
                                aria-label="Close"
                                onClick={() => confirmCancel()}
                            >
                                <span aria-hidden="true">
                                    <img src="/img/close.svg" alt="" />
                                </span>
                            </button>
                        </div>
                        <div class="header-mod-top d-flex">
                            <div>
                                <label for="" class="btn-new-noti btn-padding-noti">
                                    Selected {isMobileRecommendation ? "Recommendations" : "Assets"}
                                    <span>{selectedAssetsIds.length}</span>
                                </label>
                            </div>
                            <div className="search search-box-asset mr-2 not-draggable">
                                <FilterSearch fieldSearch={fieldSearch} setFieldSearch={setFieldSearch} fields={fieldsToBeRendered} />
                            </div>
                        </div>
                        <div className="tab-active location-sec recom-sec main-dtl-add recommendation-form add-recommendation not-draggable">
                            <div className="col-md-12 detail-recom add-details-outer">
                                <div className="outer-rcm recommendations">
                                    <div className="cnt-sec">
                                        <div className="row">
                                            <div className="col-md-12 pr-0 asset-multi-edit">
                                                <div id="accordion">
                                                    {fieldSearch?.trim()?.length && dataNotFound ? (
                                                        <div className="h-100 text-center">No fields found.</div>
                                                    ) : (
                                                        assetBands
                                                            ?.filter(band => {
                                                                if (!isMobileRecommendation) return true;

                                                                const isAssetBand = band?.toLowerCase()?.includes("asset");

                                                                const recommendationType = asset?.recommendation_type?.value?.toLowerCase() || "";

                                                                if (isAssetBand) {
                                                                    return recommendationType === "asset";
                                                                }

                                                                return true;
                                                            })
                                                            ?.map((band, i) => {
                                                                let mainFields = [];
                                                                let restFields = [];
                                                                let containsSearchedItems = false;

                                                                bandData?.[band]?.fields
                                                                    ?.filter(eachField => {
                                                                        if (!eachField) return false;

                                                                        const recommendationType =
                                                                            asset?.recommendation_type?.value?.toLowerCase() || "";

                                                                        if (isMobileRecommendation) {
                                                                            const fieldName =
                                                                                Object.values(eachField)?.[0]?.field_name?.toLowerCase();

                                                                            if (
                                                                                recommendationType === "asset" &&
                                                                                hiddenFieldsForAsset.includes(fieldName)
                                                                            ) {
                                                                                return false;
                                                                            }

                                                                            if (fieldSearch?.trim()?.length) {
                                                                                const label =
                                                                                    Object.values(eachField)?.[0]?.label?.toLowerCase() || "";
                                                                                return label.includes(fieldSearch.toLowerCase());
                                                                            }

                                                                            return true;
                                                                        } else {
                                                                            if (fieldSearch?.trim()?.length) {
                                                                                const label =
                                                                                    Object.values(eachField)?.[0]?.label?.toLowerCase() || "";
                                                                                return label.includes(fieldSearch.toLowerCase());
                                                                            }
                                                                            return true;
                                                                        }
                                                                    })

                                                                    ?.forEach((eachField, i) => {
                                                                        const fieldvalue = Object?.values(eachField)?.[0];
                                                                        if (fieldSearch?.trim()?.length && !containsSearchedItems)
                                                                            containsSearchedItems = fieldvalue?.label
                                                                                ?.toLowerCase()
                                                                                ?.includes(fieldSearch.toLowerCase());
                                                                        if (i < 3) mainFields = [...mainFields, fieldvalue];
                                                                        else restFields = [...restFields, fieldvalue];
                                                                    });
                                                                if (fieldSearch?.trim()?.length && !containsSearchedItems) return null;
                                                                return (
                                                                    <AssetBand
                                                                        label={band}
                                                                        bandId={`band${i + 1}`}
                                                                        key={i + 1}
                                                                        handleBandClick={handleBandClick}
                                                                        showBand={showBand}
                                                                        MainFields={
                                                                            isMobileRecommendation ? (
                                                                                <>
                                                                                    {band === "Priority" &&
                                                                                        (fieldSearch === "" ||
                                                                                            "priority"?.includes(fieldSearch?.toLowerCase())) && (
                                                                                            <div className="txt-rcm col-md-3">
                                                                                                <div className="content-inp-card blue-sec">
                                                                                                    <h3 className="p-name">Priority Total</h3>
                                                                                                    <h3 className="color-white">
                                                                                                        {asset?.priority?.value || 0}
                                                                                                    </h3>
                                                                                                </div>
                                                                                            </div>
                                                                                        )}

                                                                                    {mainFields
                                                                                        ?.filter(e => e?.field_name !== "priority")
                                                                                        ?.map((eachField, i) => renderFormField(eachField, i, band))}
                                                                                </>
                                                                            ) : (
                                                                                mainFields.map(eachField => renderFormField(eachField, i))
                                                                            )
                                                                        }
                                                                        RestFields={restFields.map(eachField => renderFormField(eachField, i, band))}
                                                                    />
                                                                );
                                                            })
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12 text-right btnOtr mt-3 mb-2">
                                    <span className="errorMessage">{showErrorBorder ? Object.values(errorParams)?.[0] : ""}</span>
                                    <button type="button" className="btn btn-secondary btnClr" onClick={() => confirmCancel()}>
                                        Cancel
                                    </button>
                                    {!updateMultipleAssetsLoading ? (
                                        <button
                                            type="button"
                                            className={`btn btn-primary btnRgion ml-2`}
                                            onClick={() => setShowGroupUpdateConfirmation(true)}
                                            disabled={_.isEqual(initialValues, asset)}
                                        >
                                            Update
                                        </button>
                                    ) : (
                                        <button type="button" className="btn btn-primary btnRgion ml-2">
                                            <div className="button-loader d-flex justify-content-center align-items-center">
                                                <div className="spinner-border text-white" role="status">
                                                    <span className="sr-only">Loading...</span>
                                                </div>
                                            </div>
                                        </button>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </Draggable>
            </div>
            {renderGroupUpdateConfirmationModal()}
            {renderConfirmationModal()}
            {renderServiceLifeChangeConfirmationModal()}
        </LoadingOverlay>
    );
};

const uniformatLevels = [
    "assets.uniformat_level_1_id",
    "assets.uniformat_level_2_id",
    "assets.uniformat_level_3_id",
    "assets.uniformat_level_4_id",
    "assets.uniformat_level_5_id",
    "assets.uniformat_level_6_id"
];

export default AssetsMultiEdit;
